import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { screenSelector } from "@client/selectors/state";
import { type AppState, ScreenType } from "@client/types";
import { init } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeSourceIdSelector } from "./selectors";

const makeMapStateToProps = () => {
  const sourceIdSelector = makeSourceIdSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    return {
      ...props,
      isEditMode: state.isEditMode,
      isMobile: screenSelector(state) === ScreenType.Mobile,
      sourceId: sourceIdSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  init: () => dispatch(init(props))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
